import { ColumnsType } from "antd/es/table"

import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import {
  CardMassPayoutResponsePayouts,
  MassPayoutResponsePayouts,
} from "@src/shared/api/generated"
import { dateTimeFormat } from "@src/shared/date"

export const massPayoutCryptoColumns: ColumnsType<MassPayoutResponsePayouts> = [
  {
    dataIndex: "id",
    render: (_, { id }) => id && <IdItem id={id} />,
    title: "ID",
  },
  {
    dataIndex: "external_id",
    title: "External\u00A0ID",
  },
  {
    dataIndex: "created_at",
    // @ts-ignore
    render: (_, { created_at }) => created_at && dateTimeFormat(created_at),
    title: "Date/Time (UTC)",
  },
  {
    dataIndex: "status",
    title: "Status",
  },
  {
    dataIndex: "address",
    render: (_, { address }) => <IdItem id={address} />,
    title: "Address",
  },
  {
    dataIndex: "amount",
    title: "Amount received",
  },
  {
    dataIndex: "fees",
    render: (_, { fees }) => {
      return <span>{fees?.total_fee}</span>
    },
    title: "Fee",
  },
  {
    dataIndex: "data",
    render: (_, { network, symbol }) => {
      const currency = GlobalCurrenciesCollection().getBySymbolNetwork({
        network: network,
        symbol: symbol,
      })

      return <span>{`${currency?.symbol_alias ?? symbol} (${network})`}</span>
    },
    title: "Currency",
  },
  {
    dataIndex: "fee_payer",
    title: "Fee Payer",
  },
  {
    dataIndex: "ext_tx_id",
    title: "TxID",
  },
]

export const massPayoutCardColumns: ColumnsType<CardMassPayoutResponsePayouts> =
  [
    {
      dataIndex: "id",
      render: (_, { id }) => id && <IdItem id={id} />,
      title: "ID",
    },
    {
      dataIndex: "created_at",
      // @ts-ignore
      render: (_, { created_at }) => created_at && dateTimeFormat(created_at),
      title: "Date/Time (UTC)",
    },
    {
      dataIndex: "card_number",
      render: (value: string) => `**** **** **** ${value.slice(-4)}`,
      title: "Card number",
    },
    {
      dataIndex: "amount",
      render: (value: string) => `${value}`,
      title: "Amount",
    },
    {
      render: (_, record) => {
        if (!record.fees) {
          return "—"
        }

        return `${record.fees.total_fee}`
      },
      title: "Fee",
    },
    {
      dataIndex: "symbol",
      title: "Symbol",
    },
  ]
